<mat-action-list class="__user-menu-actions">
  <zef-scrollbar
    class="__scroll"
    showScrollButtonsV
    [delayDestroy]="400"
    maxHeight="calc(100vh - 250px)">
    <button
      *ngFor="let item of data"
      mat-list-item
      type="button"
      class="__client-user-select-button"
      matTooltipClass="c-zerops-tooltip c-zerops-tooltip--constrained"
      matTooltipPosition="above"
      [matTooltip]="'You are invited to ' + item.client.accountName + ' as the ' + ( item.roleCode | roleTranslate:item.canCreateProjects) + ', but you need to accept the invitation using a link sent to your email address, ' + item.user.email + '.'"
      [matTooltipDisabled]="item.status !== clientUserStatuses.waitingAuthorization"
      [style.cursor]="item.status !== clientUserStatuses.active ? 'not-allowed' : 'pointer'"
      (click)="item.status === clientUserStatuses.active ? selected.emit(item) : undefined">
      <div
        class="__row"
        [class.__row--pending]="item.status === clientUserStatuses.waitingAuthorization">
        <zui-client-list-item
          class="__row-item"
          [web]="item.client.webUrl"
          [avatar]="item.client.avatar?.smallAvatarUrl"
          [name]="item.client.accountName"
          [maxNameWidth]="140"
          [roleCode]="item.roleCode"
          [canCreateProjects]="item.canCreateProjects"
          [canViewFinances]="item.canViewFinances"
          [canEditFinances]="item.canEditFinances">
        </zui-client-list-item>

        @if (item.status === clientUserStatuses.waitingAuthorization) {
          <mat-icon class="__pending-icon" fontSet="material-icons-outlined">mail_lock</mat-icon>
        }
      </div>
    </button>
  </zef-scrollbar>
</mat-action-list>